import React from 'react';
import { connect } from 'react-redux';
import { UIDProvider } from 'dibs-uid';
import { object, func } from 'prop-types';
import { PrepareRelayContextProvider } from '../PrepareRelayContextProvider/PrepareRelayContextProvider';

import Header from '../Header/Header';

function HeaderRenderer(props) {
    const { environment, initialVariables, query, relayVariables, messageBannerRenderer } = props;

    const variables = {
        ...initialVariables,
        ...relayVariables,
    };

    return (
        <UIDProvider prefix="header">
            <PrepareRelayContextProvider
                environment={environment}
                query={query}
                variables={variables}
                render={({ props: rendererProps }) => (
                    <Header
                        {...rendererProps}
                        {...variables}
                        messageBannerRenderer={messageBannerRenderer}
                    />
                )}
            />
        </UIDProvider>
    );
}

HeaderRenderer.propTypes = {
    environment: object,
    initialVariables: object,
    query: object,
    relayVariables: object,
    messageBannerRenderer: func,
};

const mapStateToProps = ({ header }) => {
    return {
        relayVariables: header.relayVariables || {},
    };
};

export default connect(mapStateToProps)(HeaderRenderer);
